import notice from "../../utils/notice";
import { PLAYLISTS } from "../helpers/routes";
import {
  getMultipartParams,
  handleResponse,
  handleFormData,
} from "../helpers/validate";

export const getPlaylistsList = async (page = 1, per_page = 10) => {
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: per_page.toString(),
  });

  return fetch(`${PLAYLISTS}/index?${params}`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error loading the Playlists list");
      throw e;
    });
};

export const createPlaylist = async (data) => {
  const formData = {
    ...data,
  };

  if (data.cover_url && data.cover_url instanceof File) {
    formData.file = data.cover_url;
  }

  delete formData.cover_url;

  const formDataToSend = handleFormData(formData);

  return fetch(
    `${PLAYLISTS}/create`,
    getMultipartParams("POST", formDataToSend)
  )
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error creating the Playlist");
      throw e;
    });
};

export const getPlaylist = async (id) => {
  return fetch(`${PLAYLISTS}/show/${id}`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error loading the Playlist");
      throw e;
    });
};

export const updatePlaylist = async (data) => {
  const formData = {
    ...data,
  };

  if (data.cover_url && data.cover_url instanceof File) {
    formData.file = data.cover_url;
  }

  delete formData.cover_url;

  const formDataToSend = handleFormData(formData);

  return fetch(`${PLAYLISTS}/update`, getMultipartParams("PUT", formDataToSend))
    .then((res) => handleResponse(res))
    .catch((e) => {
      notice("Error updating the Playlist");
      throw e;
    });
};

export const deletePlaylist = async (id) => {
  return fetch(`${PLAYLISTS}/delete/${id}`, getMultipartParams("DELETE"))
    .then((res) => handleResponse(res))
    .then((json) => {
      notice("Playlist deleted", "success");
      return json;
    })
    .catch((e) => {
      notice("Error deleting Playlist");
      throw e;
    });
};
